import { useStateCode } from '@/src/common/hooks/useMortgageModuleGeoIPBehavior'
import { useMortgageModuleWebviewFlow } from './useMortgageModuleWebviewFlow'
import type { StateBehavior } from '../statsig/store/useMortgageModuleWebviewFlowParameterStore'
import { isE2E } from '@/src/common/environment'

const DEFAULT_BEHAVIOR = { type: 'hide' } satisfies StateBehavior
const E2E_STATE = 'OR'

export function useMortgageModuleStateBehavior(): StateBehavior | 'loading' | 'uninitialized' {
  const stateCode = useStateCode()
  const stateMapping = useMortgageModuleWebviewFlow()

  switch (stateCode) {
    case 'uninitialized':
    case 'loading':
      return stateCode
  }

  if (stateMapping === 'loading') {
    return 'loading'
  }

  if (stateCode === 'error') {
    return DEFAULT_BEHAVIOR
  }

  if (stateMapping === 'error') {
    return DEFAULT_BEHAVIOR
  }

  if (isE2E) {
    // for e2e, just bypass and use a state that we know will be in the mapping
    return stateMapping[E2E_STATE] || DEFAULT_BEHAVIOR
  }

  return (
    stateMapping[stateCode.stateCode] ||
    // Check if the state code is in the state mapping
    stateMapping['$default'] ||
    DEFAULT_BEHAVIOR
  )
}
